const MinusIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      fill="#181A1C"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <path d="M22.667 15.334H9.333v1.333h13.334v-1.333z" fill="current"></path>
    </svg>
  );
};

export default MinusIcon;
